<template>
  <div class="row">
    <div class="col-sm-12">
      <label class="gray">{{ label }}(<span class="inform">15Mbまで</span>)<span v-if="isRequired" class="badge badge-danger ml-2">必須</span></label>
      <p v-if="suggestion" class="m-0 suggestion" style="font-size: .8rem; color: #666;">{{ suggestion }}</p>
    </div>
    <div class="col-sm-12 relative">
      <div :class="`mb-2 ${imgClass}`" @click="$refs.imageFile.click()">
        <img :src="image_file" class="img-responsive" alt="" />
      </div>
      <div class="form-group m-0">
        <div class="input-group">
          <div class="custom-file">
            <input type="file" :name="name" ref="imageFile" class="custom-file-input" :accept="accept" @change="changeImage">
          </div>
        </div>
        <div class="txtError" v-if="error">
          * {{ error }}
        </div>
      </div>
      <img v-if="image_file != '/imgs/no-image.jpeg'" src="/imgs/remove.png" class="img-remove" @click="removeFile" />
    </div>
    <input type="hidden" :name="`${name}_delete`" v-model="imageDelete" />
  </div>
</template>
<script>
  export default {
    props: ['origin', 'error', 'label', 'name', 'suggestion', 'isRequired', 'accept', 'imgClass'],
    components: {
    },
    data() {
      return {
        profileImage: undefined,
        imageDelete: 0
      }
    },
    mounted() {
      if (this.origin && this.origin != '') this.profileImage = this.origin
    },
    beforeDestroy() {
    },
    methods: {
      changeImage(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;

        let size = files[0].size / 1024;
        if (size > 15360) {
          toastr.fire({
            type: 'warning',
            icon: 'warning',
            text: "15mbまで選択してください。"
          })

          this.$refs.imageFile.value = '';
          return;
        }
        
        this.createImage(files[0]);
      },
      createImage(file) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.profileImage = e.target.result;
          this.imageDelete = 0
          this.$forceUpdate();
        };
        reader.readAsDataURL(file);
      },
      removeFile() {
        this.profileImage = undefined
        this.imageDelete = 1
        this.$refs.imageFile.value = ''
      }
    },
    computed: {
      image_file() {
        if (this.profileImage !== undefined) return this.profileImage;

        return '/imgs/no-image.jpeg';
      },
      hasImage() {
        return this.image_file !== undefined && this.image_file !== '/imgs/no-image.jpeg';
      }
    }
  }
</script>
<style scoped lang="scss">
.invalid {
    border: 1px solid #f00;
}
.is-avatar {
    width: 120px;
    height: 120px;
    padding: 0px;
    overflow: hidden;
    border-radius: 50%;
}

.no-image.salon-thumb {
    background: #eee;
    border: 1px solid #ccc;

    .image-upload {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0px;
        left: 0px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 100%;
            height: 50px;
            object-fit: contain;
            display: block;
            position: relative;
        }

        p {
            color: #999;
            margin-top: 10px;
        }
    }

    .image-overlay {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        cursor: pointer;
    }
}

.input-group>.custom-file {
    display: none;
}

.is-small {
    max-width: 300px;
    height: 200px;
    padding-top: 0;
}
</style>
